export default __webpack_public_path__ + "static/media/Invoice.8ca2add8.svg";